module.exports = new __parcel__URL__("design.e096ff32.svg").toString();